import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

/**
 * Displays section titles with consistent styling
 * @param {Object} props - Component props
 * @param {string} props.children - Title text
 * @returns {React.ReactElement} CardTitle component
 */
export const CardTitle = ({ children }) => (
  <Typography
    variant="h5"
    component="div"
    sx={{
      color: "var(----Color-Text-Primary-On-Light)",
      fontFamily: 'var(--font-family-primary, "DM Sans")',
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "28px",
      letterSpacing: "var(--font-spacing-regular, 0px)"
    }}
  >
    {children}
  </Typography>
);

CardTitle.propTypes = {
  children: PropTypes.node.isRequired
};
